// eslint-disable-next-line import/prefer-default-export
export const RECENTLY_UPDATED_CLASSNAMES =
  'highlight-input bg-blue-10 text-blue-70';
export const RECENTLY_UPDATED_HIGHLIGHT_DURATION = 10000; // in milliseconds
